
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Table from 'react-bootstrap/Table';
import { Form } from 'react-bootstrap';
import { useState } from 'react';
import axios from 'axios';
import { withAuth } from '../../api/withAuth';
import { useAuth } from '../../contexts/authContext';
import { Events } from '../../firebase/telemetry';
import { logError } from '../../firebase/errorReporting';

const GoldFinderApi = withAuth(axios.create({
    baseURL: process.env.REACT_APP_GOLD_FINDER_API_URL
}))


export const SampleReporter = (props) => {

    const { currentUser } = useAuth()

    const [useANumber, setUseANumber] = useState(false);
    const [commentText, setCommentText] = useState("");


    const storeReport = () => {
        // Validate that notes are provided
        if (!commentText.trim()) {
            alert("Please provide notes before submitting the report.");
            return;
        }

        if (useANumber) {
            const data = {
                reporting_user: currentUser.email,
                anumber: props.reportedAssay.anumber,
                notes: commentText
            };
            GoldFinderApi.post("/soil-samples/report/anumber", {
                data
            }).then(() => Events.sampleReported('soil_assay_anumber'))
              .catch(err => logError(err, { component: 'SampleReporter', action: 'report_anumber' }))
        } else {
            const data = {
                reporting_user: currentUser.email,
                anumber: props.reportedAssay.anumber,
                sample_id: props.reportedAssay.id,
                notes: commentText
            };
            GoldFinderApi.post("/soil-samples/report/sample", {
                data
            }).then(() => Events.sampleReported('soil_assay_sample'))
              .catch(err => logError(err, { component: 'SampleReporter', action: 'report_sample' }))
        }
        props.onHide()

        // reset values back to default
        setCommentText("");
        setUseANumber(false);
    }


    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Report Soil Sample
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Table striped bordered className='mb-3'>
                    <tbody>
                        <tr>
                            <td>ID:</td>
                            <td>{props.reportedAssay.id}</td>
                        </tr>
                        <tr>
                            <td>Au PPB:</td>
                            <td>{props.reportedAssay.au_ppb}</td>
                        </tr>
                        <tr>
                            <td>Sample Type:</td>
                            <td>{props.reportedAssay.surfacesampletype}</td>
                        </tr>
                        <tr>
                            <td>A Number:</td>
                            <td>
                                <a target="_blank" href={`https://wamex.dmp.wa.gov.au/Wamex/Search/ReportDetails?ANumber=${props.reportedAssay.anumber}`}>
                                    {props.reportedAssay.anumber}
                                </a>
                            </td>
                        </tr>
                        <tr>
                            <td>Company Sample ID:</td>
                            <td>{props.reportedAssay.companysampleid}</td>
                        </tr>
                    </tbody>
                </Table>
                <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlTextarea1"
                >
                    <Form.Label>Notes <span style={{color: 'red'}}>*</span></Form.Label>
                    <Form.Control as="textarea"
                        rows={3}
                        value={commentText}
                        onChange={e => setCommentText(e.target.value)}
                        placeholder="Please provide details about why you're reporting this sample..."
                        required />
                </Form.Group>
                <Form.Check // prettier-ignore
                    id="mark_whole_anumber"
                    name="mark_whole_anumber"
                    label='Report all samples in A Number'
                    checked={useANumber}
                    onChange={() => setUseANumber(!useANumber)}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" className="pull-left" onClick={props.onHide}>Cancel</Button>
                <Button 
                    variant="primary" 
                    onClick={() => storeReport()} 
                    disabled={!commentText.trim()}
                >
                    Report
                </Button>
            </Modal.Footer>
        </Modal>
    );
}